/**
 * Responsible gambling — `/betting-gaming/responsible-gambling`
 */
import { RESPONSIBLE_GAMBLING_SLUG, responsibleGamblingDefaultData } from "./responsibleGamblingData";
import {
  ResponsibleGamblingArticlesTab,
  ResponsibleGamblingMediaTab,
  ResponsibleGamblingOverviewTab,
} from "./ResponsibleGamblingDesign";

export const responsibleGamblingModule = {
  slug: RESPONSIBLE_GAMBLING_SLUG,
  getDefaultData: () => responsibleGamblingDefaultData,
  Views: {
    overview: ResponsibleGamblingOverviewTab,
    articles: ResponsibleGamblingArticlesTab,
    media: ResponsibleGamblingMediaTab,
  },
};
